import { store } from 'app/store';
import axios from 'axios';
import { DashboardSliceDataInterface } from 'store/dashboard/dasboardSlice.interface';
import urls from 'utils/urls';

const state = store.getState();

export const getDashboardService: () => Promise<{ data: DashboardSliceDataInterface }> = () => {
  try {
    const dashboard = state.dashboard.data;
    if (dashboard) {
      return Promise.resolve({ data: dashboard });
    } else {
      return axios
        .get(urls.dashboard)
        .then((res) => {
          return { data: res.data.response as DashboardSliceDataInterface };
        })
        .catch((err) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};
